const URL_DESCRICAO_POR_FUNCAO = [
    { chave: 'cancelamento', texto: 'Insira a URL que deve receber a notificação do AgroReceita quando uma receita for cancelada.' },
    { chave: 'emiss', texto: 'Insira a URL que deve receber a notificação do AgroReceita quando uma receita for emitida.' },
    { chave: 'fazenda', texto: 'Insira a URL que deve receber a notificação do AgroReceita quando uma fazenda for cadastrada.' },
];

export const descricaoUrlPorFuncao = (funcao) => {
    const normalizado = (funcao || '').toLowerCase();
    const encontrado = URL_DESCRICAO_POR_FUNCAO.find((item) => normalizado.includes(item.chave));

    return encontrado
        ? encontrado.texto
        : 'Insira a URL que deve receber a notificação do AgroReceita quando o evento desta integração ocorrer.';
};

export default descricaoUrlPorFuncao;
